<div class="w-full h-screen">
    <div class="flex justify-center h-full">
        <div class="flex flex-col w-4/5 max-w-screen-sm">
            <!-- /Sign in Box -->
            <div class="flex flex-col h-full place-content-center">
                <form class="login-form" [formGroup]="resetPasswordGroup" (ngSubmit)="resetPassword()">
                    <div>
                        <h2 class="font-bold text-3xl my-8">Reset Password</h2>
                    </div>
                    <!-- Email -->
                    <div class="mb-4">
                        <div class="w-full">
                            <span class="field-label">E-mail address</span>
                            <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                                <input matInput type="text" placeholder="E-mail address" formControlName="email" />
                                <mat-error *ngIf="resetPasswordGroup.controls['email'].errors?.['required']">
                                    Email is required
                                </mat-error>
                                <mat-error *ngIf="resetPasswordGroup.controls['email'].hasError('email')">
                                    Invalid email address
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- Buttons-->
                    <div class="mb-6 w-full">
                        <div class="flex flex-col lg:flex-row gap-2 place-content-between">
                            <div class="flex flex-row items-center">
                                <button mat-flat-button class="w-48 lg:w-auto button-primary"
                                    [disabled]="resetPasswordGroup.invalid || disableResetPwdBtn" type="submit">
                                    Reset Password
                                </button>
                                <!-- Loader -->
                                <div class="w-auto h-full pl-2 flex flex-row place-content-between items-center"
                                    *ngIf="loading">
                                    <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                                </div>
                            </div>

                            <button class="w-48 lg:w-auto button-secondary" mat-flat-button type="button"
                                (click)="backToLogin()">
                                <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                                Back to login
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
